import { BannerCopy, BannerCopyBlock, BannerIcon, BannerMeta, BannerRoot, BannerTitle } from './styled';
import type { StateBannerProps } from './types';
import { getStateBanner } from './utils';

const StateBanner = ({ ops }: StateBannerProps) => {
  const banner = getStateBanner(ops);
  if (!banner) return null;

  return (
    <BannerRoot tone={banner.tone} role="status" data-testid="idv-state-banner" data-tone={banner.tone}>
      <BannerIcon aria-hidden>{banner.icon}</BannerIcon>
      <BannerCopyBlock>
        <BannerTitle>{banner.title}</BannerTitle>
        <BannerCopy>{banner.copy}</BannerCopy>
        {banner.meta ? <BannerMeta>{banner.meta}</BannerMeta> : null}
      </BannerCopyBlock>
    </BannerRoot>
  );
};

export default StateBanner;
